import {Dropdown} from "primereact/dropdown";
import {useSelector} from "react-redux";

import {useSelectByCurrentLanguage} from "../../hooks/languageHooks";
import {selectSegment} from "../../redux/objectParametersSlice";
import {selectSingleApiParamOutputDefCurried} from "../../redux/specSelectors";
import NhkHouseSchema, {isNhkHouseCode} from "./NhkHouseSchema";
import ParameterFieldContainer from "./ParameterFieldContainer";
import {getResourceColor} from "./paramHooks";

export default function ParameterInputBuildingCategoryNhk({parameterType}) {
    const selectLang = useSelectByCurrentLanguage();
    const paramDef = useSelector(selectSingleApiParamOutputDefCurried("building_category_nhk_cat"));
    const segment = useSelector(selectSegment);
    const segmentFilter = {
        EZFH_K: (category) => /^(\d+)\..*/.exec(category.shortNameDe)?.[1] < 4,
        MFHWGH_K: (category) => /^(\d+)\..*/.exec(category.shortNameDe)?.[1] >= 4,
    };
    const categories = paramDef.categories.filter((category) => {
        return segmentFilter[segment]?.(category) ?? true;
    });
    const valueLabels = categories.reduce((acc, {shortNameDe, shortNameEn, titleDe, titleEn}) => {
        acc[shortNameDe] = selectLang(titleDe, titleEn);
        return acc;
    }, {});
    const options = categories
        .toSorted((a, b) => a.shortNameDe - b.shortNameDe)
        .map(({shortNameDe, shortNameEn}) => {
            return {value: shortNameDe, label: `${shortNameDe} ${valueLabels[shortNameDe]}`};
        });

    return (
        <ParameterFieldContainer
            id={"input_building_category"}
            showDescription={true}
            parameter={"building_category_nhk"}
            parameterType={parameterType}
            valueLabels={valueLabels}
            renderControl={({className, onChange, activeParameterType, hasConflict, value, disabled}) => {
                const color = getResourceColor(activeParameterType, hasConflict);

                return (
                    <Dropdown
                        id={"building_category"}
                        value={value}
                        valueTemplate={(option) => (
                            <span className={`text-${color}`}>{option ? option.label : "&nbsp;"}</span>
                        )}
                        className={`w-full building_category_nhk border-${hasConflict ? color : ""}`}
                        disabled={disabled}
                        pt={{
                            button: {
                                className: `p-button-sm ${className}`,
                            },
                        }}
                        options={options}
                        optionLabel="label"
                        itemTemplate={(option) => (
                            <div className="flex items-center gap-2">
                                {isNhkHouseCode(option.value) && (
                                    <NhkHouseSchema code={option.value} scale={0.35} className="shrink-0 bg-white" />
                                )}
                                <span>{option.label}</span>
                            </div>
                        )}
                        onChange={onChange}
                        scrollHeight="300px"
                        data-pr-position="top"
                    />
                );
            }}
        />
    );
}
